import React from 'react';
import { isToday, parseISO } from 'date-fns';
import { dayShort, num, weekRange, weekTitle } from './weeklyPlanUtils';

const DayCell = ({ day, selected, onSelect }) => {
  const today = isToday(parseISO(day.date));
  const busy = day.order_count > 0;
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`rounded-md border px-2 py-2 text-left transition-colors duration-150 ${selected ? 'border-[#005F73] ring-1 ring-[#005F73]/40' : 'border-zinc-200'} ${busy ? 'bg-white hover:bg-[#005F73]/5' : 'bg-zinc-50 text-zinc-400'} ${today ? 'shadow-[inset_0_3px_0_#005F73]' : ''}`}
      data-testid={`wp-day-${day.date}`}
    >
      <div className={`text-[11px] font-medium ${today ? 'text-[#005F73]' : 'text-zinc-500'}`}>{dayShort(day.date)}</div>
      <div className="text-xl font-bold font-mono leading-tight text-zinc-900" data-testid={`wp-day-units-${day.date}`}>{busy ? num(day.units, 1) : '–'}</div>
      <div className="text-[10px] text-zinc-500">{busy ? `units · ${day.order_count} order${day.order_count === 1 ? '' : 's'}` : 'no orders'}</div>
    </button>
  );
};

export const WeekDayStrip = ({ week, selectedDay, onSelectDay, active, onActivate }) => (
  <div className={`grid grid-cols-[120px_repeat(7,minmax(0,1fr))] gap-1.5 items-stretch rounded-lg p-1 ${active ? 'bg-[#005F73]/[0.04]' : ''}`} data-testid={`wp-week-${week.start}`}>
    <button type="button" onClick={onActivate} className="text-left px-2 py-1 rounded-md hover:bg-zinc-100 transition-colors duration-150" data-testid={`wp-week-select-${week.start}`}>
      <div className="text-sm font-semibold text-zinc-900">{weekTitle(week).split(',')[0]}</div>
      <div className="text-[10px] text-zinc-500">{weekRange(week)}</div>
      <div className="mt-1 text-lg font-bold font-mono text-[#005F73]" data-testid={`wp-week-units-${week.start}`}>{num(week.units, 1)}</div>
      <div className="text-[10px] text-zinc-500">units · {week.order_count} orders</div>
    </button>
    {week.days.map((d) => (
      <DayCell key={d.date} day={d} selected={active && selectedDay === d.date} onSelect={() => { onActivate(); onSelectDay(selectedDay === d.date ? null : d.date); }} />
    ))}
  </div>
);
